import { render, staticRenderFns } from "./MiniProfile.vue?vue&type=template&id=1bab58e3&scoped=true"
import script from "./MiniProfile.vue?vue&type=script&lang=ts"
export * from "./MiniProfile.vue?vue&type=script&lang=ts"
import style0 from "./MiniProfile.vue?vue&type=style&index=0&id=1bab58e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab58e3",
  null
  
)

export default component.exports